import { useLazyQuery } from '@apollo/client';
import { SEARCH_VEHICLES_QUERY } from '../app/schemas/searchVehicleSchema';
import type { SearchInventoryResponse } from '../types';

const useFetchSitewideSearch = () => {
  const [searchVehicles, { data, loading, error }] = useLazyQuery<SearchInventoryResponse>(
    SEARCH_VEHICLES_QUERY,
    {
      fetchPolicy: 'no-cache',
    },
  );

  const listOfVehicles = data?.inventorySearch?.groups;
  const warnings = data?.inventorySearch?.warnings;
  return { searchVehicles, listOfVehicles, warnings, loading, error };
};

export default useFetchSitewideSearch;
